import React from "react";
import { File as FileIcon, Download } from "lucide-react";

const File = ({ file, parentPath, userID }) => {
  // Function to truncate filename
  const truncateFileName = (name, maxLength = 20) => {
    if (name.length <= maxLength) return name;
    const extension = name.split('.').pop();
    const baseName = name.substring(0, name.lastIndexOf('.'));
    return `${baseName.substring(0, maxLength - extension.length - 3)}...${extension}`;
  };

  return (
    <a
      href={file.fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block relative rounded-xl p-5 
        bg-gray-50 
        hover:bg-green-50 
        border border-gray-200 hover:border-green-200
        shadow-sm hover:shadow-md
        transition-all duration-300 ease-in-out 
        transform hover:-translate-y-1 
        focus:outline-none focus:ring-2 focus:ring-green-300
        group"
    >
      <div className="flex flex-col items-center justify-center text-center relative">
        <div className="mb-3 p-3 ">
          <FileIcon 
            className="w-8 h-8 text-green-600 
            group-hover:text-green-700 
            transition-colors duration-200"
          />
        </div>
        <span 
          className="text-sm font-medium text-gray-800 
          group-hover:text-green-700 
          truncate max-w-full 
          transition-colors duration-200 
          block mb-1"
        >
          {truncateFileName(file.fileName)}
        </span>
        
        {/* File size information */}
        <span className="text-xs text-gray-500 group-hover:text-green-600 transition-colors duration-200">
          {(file.fileSize / 1024).toFixed(1)} KB
        </span>

        {/* Download icon */}
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <Download 
            className="w-4 h-4 text-green-600 
            hover:text-green-800 
            transition-colors duration-200"
          />
        </div>
      </div>
    </a>
  );
};

export default File;